import FormListBox from "../../../components/ui-lib/form/FormListBox";
import {
  AbsenceReason,
  absenceReasonMapper,
} from "../../../models/vacancy/vacancy";
import { FormWizardStepProps } from "../../../models/form-wizard-step-props";
import { VacancyFormFields } from "../VacancyCreateWizard";
import { SortAlphabetically } from "../../../helpers/helper-functions";

function VacancyReasonStep({
  control,
  register,
  errors,
}: FormWizardStepProps<VacancyFormFields>) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="space-y-4">
        <h2
          className="text-center text-th-primary-900"
          data-cy="wizard-step-title"
        >
          Grund des Ausfalles
        </h2>
        <FormListBox
          className="md:w-[300px]"
          name="absenceReason"
          control={control}
          values={Object.values(AbsenceReason).sort(SortAlphabetically)}
          valueKey={absenceReasonMapper}
          itemDisabled={(_) => false}
          errors={errors as any}
          rules={{
            required: "Sie müssen einen Ausfallgrund selektieren",
          }}
          placeholder="Ausfallgrund"
        ></FormListBox>
      </div>
    </div>
  );
}

export default VacancyReasonStep;
